const OFFLINE = {
  code: 'network_error',
  message: "We couldn't reach Spotsurfer. Check your connection and try again.",
};

export const useApiV2 = () => {
  const config = useRuntimeConfig();
  const base = `${config.public.apiUrl.replace(/\/$/, '')}/api/v2`;

  const request = async (method, path, body, retried = false) => {
    const token = useTokens().access;
    try {
      const reply = await $fetch(`${base}${path}`, {
        method,
        body,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      return { data: reply?.data ?? null, error: null };
    } catch (failure) {
      const error = failure?.data?.error ?? OFFLINE;
      if (error.code === 'session_expired' && !retried && useTokens().refresh) {
        try {
          await useRefreshSession();
        } catch {
          return { data: null, error };
        }
        return request(method, path, body, true);
      }
      return { data: null, error };
    }
  };

  return {
    get: (path) => request('GET', path),
    post: (path, body) => request('POST', path, body),
    patch: (path, body) => request('PATCH', path, body),
    delete: (path) => request('DELETE', path),
  };
};
